import {
  CancelSubscriptionReason,
  PaginationRequest,
  Plan,
  Subscription,
  SubscriptionStatus,
} from '@aibees/shared/definition';
import { PlanCapability } from './plan-entitlements';

export interface BrowseSubscriptionPlanRequest extends PaginationRequest {}

export interface BrowseSubscriptionPlanResponse extends Array<Plan> {}

export enum PlanEntitlementAccess {
  GRANTED = 'GRANTED',
  LOCKED = 'LOCKED',
  COMING_SOON = 'COMING_SOON',
}

export interface PlanEntitlementCapability {
  access: PlanEntitlementAccess;
  comingSoon: boolean;
}

export interface PlanEntitlementSubscription {
  enforced: boolean;
  free: boolean;
  status: SubscriptionStatus;
}

export interface BrowseCurrentPlanEntitlementsResponse {
  capabilities: Record<PlanCapability, PlanEntitlementCapability>;
  /** Only the capabilities that carry a numeric cap are present. */
  limits: Partial<Record<PlanCapability, number>>;
  subscription: PlanEntitlementSubscription;
}

export interface CurrentSubscriptionRequest {}
export type CurrentSubscriptionResponse = Subscription;

export interface CancelSubscriptionRequest {
  feedback: CancelSubscriptionReason;
  comment?: string;
}

export type CancelSubscriptionResponse = Subscription;

export interface UpgradeSubscriptionPlanRequest {
  plan: string;
  redirect?: {
    success: string;
    failed: string;
  };
}
export interface UpgradeSubscriptionPlanResponse {
  id: string;
  url: string;
}

export enum SubscriptionActiveAction {
  SCHEDULE = 'schedule',
  IMMEDIATELY = 'immediately',
}

export enum PlanInterval {
  YEAR = 'YEAR',
  MONTH = 'MONTH',
}
